import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useState } from "react";
import { useEffect } from "react";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function CheckBoxTagProDevice({
  options,
  labelFields = [],
  onChange,
  setInputSearch,
  defaultValue,
}) {
  const [selectedItems, setSelectedItems] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (defaultValue.length) {
      setSelectedItems(defaultValue.map((value) => value.macAddress));
    }
  }, [defaultValue]);

  const renderLabelField = (option) => {
    let str = "";
    for (let i = 0; i < labelFields.length; i++) {
      const label = labelFields[i];
      if (i === labelFields.length - 1) {
        str += `${option[label]}`;
      } else {
        str += `${option[label]} - `;
      }
    }

    return str;
  };

  const handleOnChange = (event, values) => {
    const listMacAddress = values.map((value) => value.macAddress);
    setSelectedItems(listMacAddress);
    onChange(values);
  };

  return (
    <Autocomplete
      key={defaultValue}
      multiple
      limitTags={2}
      id="checkboxes-tags-demo"
      // inputValue={inputValue}
      defaultValue={[...defaultValue]}
      disableCloseOnSelect
      filterOptions={createFilterOptions({
        limit: 10,
      })}
      onChange={(event, value) => handleOnChange(event, value)}
      onInputChange={(event, newInputValue) => {
        setInputSearch(newInputValue);
      }}
      options={options.filter(
        (option) => !selectedItems.includes(option.macAddress)
      )}
      getOptionLabel={(option) => renderLabelField(option, labelFields)}
      filterSelectedOptions
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {renderLabelField(option, labelFields)}
        </li>
      )}
      style={{ margin: "10px 0" }}
      renderInput={(params) => (
        <TextField
          {...params}
          onChange={(e) => setInputValue(e.target.value)}
          label="MacAddress"
          placeholder="MacAddress"
        />
      )}
    />
  );
}
